import { PREFERENCES_ACCOUNT_PAGE_URL } from '@/api/core/links';
import { useAuth } from '@/app/modules/auth/core/Auth';
import { type FC } from 'react';
import { Link } from 'react-router-dom';
import SafeImage from '../../../../app/modules/widgets/SafeImage';
import { type HeaderUserMenuProps } from './_types';

const HeaderAccountantMenu: FC<HeaderUserMenuProps> = ({ isOpen, onClose }) => {
  const { currentUser, logout } = useAuth();

  if (!isOpen) return null;

  return (
    <div
      className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-350px show position-absolute"
      style={{ top: '100%', right: 0, zIndex: 1050, marginTop: '8px' }}
    >
      <div className="menu-item px-3">
        <div className="menu-content d-flex align-items-center px-3">
          <div className="symbol symbol-50px me-5">
            <SafeImage
              alt="Imagem do usuário"
              className="mb-4 align-self-center rounded cursor-pointer"
              fallbackName={currentUser?.name}
              height={50}
              src={currentUser?.profile_picture_url}
              width={50}
            />
          </div>

          <div className="d-flex flex-column">
            <div className="fw-bolder d-flex align-items-center fs-5">
              {currentUser?.name}
              <span className="badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2">
                {currentUser?.type?.description}
              </span>
            </div>
            <a
              className="fw-bold text-muted text-hover-primary fs-7 text-truncate"
              href="#"
              style={{ maxWidth: '250px', display: 'block' }}
            >
              {currentUser?.email}
            </a>
          </div>
        </div>
      </div>

      <div className="separator my-2" />

      <div className="menu-item px-5 my-1">
        <Link className="menu-link px-5" to={PREFERENCES_ACCOUNT_PAGE_URL} onClick={onClose}>
          Configurações da conta
        </Link>
      </div>

      <div className="menu-item px-5">
        <a
          className="menu-link px-5"
          onClick={() => {
            onClose();
            logout();
          }}
        >
          Sair
        </a>
      </div>
    </div>
  );
};

export { HeaderAccountantMenu };
